// src/features/itinerary/components/Itinerary.jsx
import React from "react";
import ItineraryDay from "./ItineraryDay";
import { groupByDay, debugTimelineForDay } from "../utils/itineraryUtils";
// import "../styles/itinerary.css"; // <- include your big CSS file here

/**
 * props:
 * - items: array of segments/tracks (mix is OK)
 *   (Use your JSON objects: transportation, accommodation, tracks, idea/activity)
 */
export default function Itinerary({ items = [] }) {
  const groupedDays = groupByDay(items);

  // Log the first day
  //debugTimelineForDay(groupedDays[0]);

  return (
    <div id="timeline" className="timeline-container">
      <h3>Itinerary</h3>
      {groupedDays.map(({ day, segments }) => (
        <ItineraryDay key={day} day={day} segments={segments} />
      ))}
    </div>
  );
}
